module.exports = "/_next/static/images/ecomm_logo-cb2754b5090f32b111b4c5f57ba88edf.svg";